export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GET_PROFILE = 'get_profile';
export const UPDATE_PROFILE = 'update_profile';
